import { Box } from '../box';

import { grid } from './grid.css';

import type { PropsWithChildren } from 'react';

export const Grid = ({ children }: PropsWithChildren) => <Box className={grid}>{children}</Box>;
